module.exports = __webpack_public_path__ + "img/wx-guide.92bf265d.png";